export const SHIP_DURATION = "3-5 Days";
export const LOCKER_INACTIVITY_FEE_TEXT =
  "An inactivity fee may apply (based on usage per quarter).";

export const PRODUCT_VIEW_TYPE = "products";
export const COLLECTION_VIEW_TYPE = "collections";
